__turbopack_context__.v({
  "associationBadge": "page-module-scss-module__UyAF4W__associationBadge",
  "associationImage": "page-module-scss-module__UyAF4W__associationImage",
  "associations": "page-module-scss-module__UyAF4W__associations",
  "avatar": "page-module-scss-module__UyAF4W__avatar",
  "avatarLink": "page-module-scss-module__UyAF4W__avatarLink",
  "avatarPlaceholder": "page-module-scss-module__UyAF4W__avatarPlaceholder",
  "banner": "page-module-scss-module__UyAF4W__banner",
  "bannerImage": "page-module-scss-module__UyAF4W__bannerImage",
  "bannerInner": "page-module-scss-module__UyAF4W__bannerInner",
  "bannerPlaceholder": "page-module-scss-module__UyAF4W__bannerPlaceholder",
  "breedsIcon": "page-module-scss-module__UyAF4W__breedsIcon",
  "breedsRow": "page-module-scss-module__UyAF4W__breedsRow",
  "breedsText": "page-module-scss-module__UyAF4W__breedsText",
  "container": "page-module-scss-module__UyAF4W__container",
  "divider": "page-module-scss-module__UyAF4W__divider",
  "field": "page-module-scss-module__UyAF4W__field",
  "fieldIcon": "page-module-scss-module__UyAF4W__fieldIcon",
  "fieldLabel": "page-module-scss-module__UyAF4W__fieldLabel",
  "fieldLabelName": "page-module-scss-module__UyAF4W__fieldLabelName",
  "fieldName": "page-module-scss-module__UyAF4W__fieldName",
  "galleryContent": "page-module-scss-module__UyAF4W__galleryContent",
  "leftCol": "page-module-scss-module__UyAF4W__leftCol",
  "leftColHeading": "page-module-scss-module__UyAF4W__leftColHeading",
  "leftColName": "page-module-scss-module__UyAF4W__leftColName",
  "leftColProviderInfo": "page-module-scss-module__UyAF4W__leftColProviderInfo",
  "messageButton": "page-module-scss-module__UyAF4W__messageButton",
  "messageIcon": "page-module-scss-module__UyAF4W__messageIcon",
  "midCol": "page-module-scss-module__UyAF4W__midCol",
  "midColContainer": "page-module-scss-module__UyAF4W__midColContainer",
  "midColHeading": "page-module-scss-module__UyAF4W__midColHeading",
  "midColName": "page-module-scss-module__UyAF4W__midColName",
  "midColProviderInfo": "page-module-scss-module__UyAF4W__midColProviderInfo",
  "photosSectionHeading": "page-module-scss-module__UyAF4W__photosSectionHeading",
  "profilePage": "page-module-scss-module__UyAF4W__profilePage",
  "profileSection": "page-module-scss-module__UyAF4W__profileSection",
  "providerInfoRow": "page-module-scss-module__UyAF4W__providerInfoRow",
  "ratingNumber": "page-module-scss-module__UyAF4W__ratingNumber",
  "registration": "page-module-scss-module__UyAF4W__registration",
  "registrationIcon": "page-module-scss-module__UyAF4W__registrationIcon",
  "registrationLabel": "page-module-scss-module__UyAF4W__registrationLabel",
  "registrationRow": "page-module-scss-module__UyAF4W__registrationRow",
  "reviewLink": "page-module-scss-module__UyAF4W__reviewLink",
  "reviewsList": "page-module-scss-module__UyAF4W__reviewsList",
  "rightCol": "page-module-scss-module__UyAF4W__rightCol",
  "section": "page-module-scss-module__UyAF4W__section",
  "sectionDivider": "page-module-scss-module__UyAF4W__sectionDivider",
  "socialLink": "page-module-scss-module__UyAF4W__socialLink",
  "socialLinks": "page-module-scss-module__UyAF4W__socialLinks",
  "starRating": "page-module-scss-module__UyAF4W__starRating",
  "tileGrid": "page-module-scss-module__UyAF4W__tileGrid",
});
